initVideo();
function initVideo() {
  const vids = document.querySelectorAll('video[autoplay="autoplay"]');

  // Set up intersection observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  });

  vids.forEach((vid) => {
    // Apply intersection observer
    observer.observe(vid);
  });
}
